import { render, staticRenderFns } from "./UfForm.vue?vue&type=template&id=53bc9cc6"
import script from "./UfForm.vue?vue&type=script&lang=js"
export * from "./UfForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports